import { UpdatedDiagnostic } from "@fairfleet/geotab";

export default function getObdCode(diagnostic: UpdatedDiagnostic): string | null {
  if (diagnostic === undefined) {
    return null;
  }
  try {
    // Determine the OBD-II DTC prefix based on the Controller ID
    let prefix = null;
    switch (diagnostic?.controller?.id) {
      case "ControllerObdPowertrainId":
      case "ControllerObdWwhPowertrainId":
        prefix = "P";
        break;
      case "ControllerObdBodyId":
      case "ControllerObdWwhBodyId":
        prefix = "B";
        break;
      case "ControllerObdChassisId":
      case "ControllerObdWwhChassisId":
        prefix = "C";
        break;
      case "ControllerObdNetworkingId":
      case "ControllerObdWwhNetworkingId":
        prefix = "U";
        break;
      default:
        break;
    }
    if (prefix !== null) {
      // Convert the Diagnostic code to a four-character hexadecimal string
      const hexCode = diagnostic?.code.toString(16).padStart(4, "0").toUpperCase();

      // Combine the prefix and hexadecimal code to form the OBD-II code
      const completeObdCode = `${prefix}${hexCode}`;

      return completeObdCode;
    }
  } catch (error) {
    console.error("Error parsing OBD-II code:", error);
    return null;
  }
  return null;
}
